import { Button, DateInput, Modal, ConfirmModal } from "components"
import moment from "moment"
import { Fragment, useState } from "react"
import toast from "react-hot-toast"
import { IoSendSharp } from "react-icons/io5"
import { useApi, useToggle } from "utils"
import TransferItemsDetail from "../../TransferItem/components/Detail"
import { PERMISION } from "security"

export function ApproveAction(props: { data: any; refetch: () => void }) {
  const { isActive, toggle } = useToggle(false)

  return (
    <Fragment>
      <Button
        type="button"
        color="ghost"
        permission={PERMISION.INVENTORY.TRANSACTION.APPROVAL_TRANSFER_ITEM.UPDATE}
        onClick={toggle}
        disabled={Boolean(
          props?.data?.approval_status === 3 ||
            props?.data?.approval_status === 4
        )}>
        <IoSendSharp />
      </Button>
      {isActive && (
        <ModalSection
          toggle={toggle}
          data={props.data}
          refetch={props.refetch}
        />
      )}
    </Fragment>
  )
}

function ModalSection(props: {
  toggle: () => void
  data: any
  refetch: () => void
}): JSX.Element {
  const api = useApi()
  const [date, setDate] = useState<string>(moment().format("YYYY-MM-DD"))
  const [confirmOpen, setConfirmOpen] = useState(false)

  const onSubmit = (date: string | undefined, status: number) => {
    return new Promise<void>((resolve) => {
      toast
        .promise(
          api.post(`/transfer/approve/${props.data.transfer_id}`, {
            approval_status: status,
            approve_date: date
          }),
          {
            loading: "Loading...",
            success: (res) => res.data.message,
            error: (err) => err.response.data.message ?? err.response.message
          }
        )
        .then(() => {
          props.toggle()
          props?.refetch && props.refetch()
        })
        .catch(() => {})
        .finally(resolve)
    })
  }

  return (
    <Modal
      isdarktitle
      isOpen
      title="APPROVAL TRANSFER"
      closeModal={props.toggle}>
      <Modal.Body>
        <TransferItemsDetail transfer_id={props.data.transfer_id} />
      </Modal.Body>

      <Modal.Footer className="flex md:flex-row flex-col justify-between md:items-end gap-3">
        <DateInput
          placeholderText="Select Date"
          selected={moment(date).toDate()}
          className="w-full"
          label="APPROVAL DATE"
          onChange={(date) => {
            const selectDate = moment(date).format("YYYY-MM-DD")
            setDate(selectDate)
          }}
        />

        <section className="flex gap-3">
          <Button onClick={props.toggle}>CANCEL</Button>
          <Button color="error" onClick={() => onSubmit(date, 3)}>
            REJECT
          </Button>
          <Button color="primary" onClick={() => {
            if(props.data.transaction_date === date){
              onSubmit(date, 4)
            }else{
              setConfirmOpen(true)
            }
          }}>
            APPROVED
          </Button>
        </section>
      </Modal.Footer>

      {/* Modal Konfirmasi */}
      {confirmOpen && (
        <ConfirmModal
          isOpen={confirmOpen}
          title="CONFIRM APPROVAL"
          confirmText="Approve"
          cancelText="Cancel"
          onCancel={() => setConfirmOpen(false)}
          onConfirm={() => {
            setConfirmOpen(false)
            onSubmit(date, 4)
          }}
        >
          <div className="space-y-2">
            <p>Do you want to approve this?</p>
            <p><b>Transaction Date:</b> {moment(props.data.transaction_date).format("DD MMM YYYY")}</p>
            <p><b>Approval Date:</b> {moment(date).format("DD MMM YYYY")}</p>
          </div>
        </ConfirmModal>
      )}

    </Modal>
  )
}
